import { all } from "redux-saga/effects";

import * as watchers from "./watchers";

export function* themeListSagas() {
  yield all([watchers.watchAddNewTheme(), watchers.watchDeleteTheme(), watchers.watchMount(), watchers.watchUnmount()]);
}
